import { render, staticRenderFns } from "./BasicsWarehouse.vue?vue&type=template&id=3941c55d&scoped=true"
import script from "./BasicsWarehouse.vue?vue&type=script&lang=js"
export * from "./BasicsWarehouse.vue?vue&type=script&lang=js"
import style0 from "./BasicsWarehouse.vue?vue&type=style&index=0&id=3941c55d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941c55d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3941c55d')) {
      api.createRecord('3941c55d', component.options)
    } else {
      api.reload('3941c55d', component.options)
    }
    module.hot.accept("./BasicsWarehouse.vue?vue&type=template&id=3941c55d&scoped=true", function () {
      api.rerender('3941c55d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsWarehouse/BasicsWarehouse.vue"
export default component.exports